import { BREAKPOINTS, CLASSES, ARIAS } from '../../utils/constants';

const initHeader = () => {
  const headerEl = document.querySelector('[data-header]');
  if (!headerEl) return;
  const navToggle = headerEl.querySelector('[data-nav-toggle]');
  const navToggleText = navToggle.querySelector('[data-nav-toggle-text]');
  const navigationEl = headerEl.querySelector('[data-navigation]');
  const announcementBarEl = document.querySelector('[data-announcement-bar]').parentElement;

  const getStickyStatus = () => {
    if (!announcementBarEl) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          headerEl.removeAttribute('data-sticky-active');
        } else {
          headerEl.setAttribute('data-sticky-active', 'true');
        }
      },
      { threshold: [0] }
    );
    observer.observe(announcementBarEl);
  };

  navToggle.addEventListener('click', () => {
    const isOpen = navToggle.classList.toggle('nav-open');
    navToggle.setAttribute(ARIAS.EXPANDED, isOpen);
    navToggleText.textContent = isOpen ? navToggleText.dataset.navToggleCloseText : navToggleText.dataset.navToggleText;
    navigationEl.classList.toggle(CLASSES.TRANSLATE_X_0);
  });

  getStickyStatus();
};

export default initHeader;
